import { render } from "./icon-font.vue?vue&type=template&id=e9d150a4&scoped=true"
import script from "./icon-font.vue?vue&type=script&lang=js"
export * from "./icon-font.vue?vue&type=script&lang=js"

import "./icon-font.vue?vue&type=style&index=0&id=e9d150a4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-e9d150a4"

export default script